import { BaseListParams } from "./baseListParams";

export class ListParams extends BaseListParams {
  searchText?: string;
  sortBy?: string;
  filter?: string;
  directSharedOnly?: boolean;

  // Underscore-prefixed params for new API style
  _sort?: string;
  _search?: string;

  constructor() {
    super();
    this.sortBy = '';
    this.searchText = '';

    this.filter = '';
    this.directSharedOnly = false;

    this._sort = '';
    this._search = '';
  }
}
